import { GeometryGenerator } from "@eplan/wgpurenderer/util/geometryGenerator";
import { Matrix4 } from "@eplan/wgpurenderer/src/renderer.js";
import { createHighlightMaterial } from "../Utils/colorUtils";

// Think of this like <CustomRect />
export async function CustomBox3D({
    renderer,
    allocator,
    storeGeometry,
    parent,
    material,
    texture,

    x = 0,
    y = 0,
    z = 0,

    width,
    height,
    depth,
    nodeName = "node"
}) {
    const node = renderer.createGraphicalNode();
    node.name = nodeName;
    const geometry = GeometryGenerator.createCubeGeometryData();
    // node.geometryId = await storeGeometry(geometry, material, texture);
    const normalGeometryId = await storeGeometry(geometry, material, texture);
    
    // ✅ HIGHLIGHT geometry (blue or strong color)
    const highlightMaterial = await createHighlightMaterial(renderer, allocator); // we define below
    const highlightGeometryId = await storeGeometry(geometry, highlightMaterial, texture);

    node.geometryId = normalGeometryId;

    // ✅ store both
    node.userData = {
        normalGeometryId,
        highlightGeometryId,
        highlighted: false
    };

    // ✅ same idea as 2D positioning — but adjusted for 3D center-based coords
    node.matrix = Matrix4.product([
        Matrix4.translation([
            x + width / 2,     // shift because cube is centered
            y + height / 2,
            z + depth / 2
        ]),
        Matrix4.scale([
            width / 2,
            height / 2,
            depth / 2
        ])
    ]);

    parent.addChild(node);

    return node;
}